module.exports = __webpack_public_path__ + "static/media/rv2.18be9592.jpg";